/* unplugin-vue-components disabled */import { render } from "./SlideBar.vue?vue&type=template&id=b48f7380&scoped=true&lang=pug"
import script from "./SlideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SlideBar.vue?vue&type=script&setup=true&lang=js"

import "./SlideBar.vue?vue&type=style&index=0&id=b48f7380&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b48f7380"]])

export default __exports__